import Engagement from '@/pages/report/engagement/routes'
import TransactionRating from '@/pages/report/transaction-rating/routes'
import ExportReport from '@/pages/report/export-report/routes'

export default {
  path: 'report',
  component: () => import('@/components/layouts/ChildLayout.vue'),
  children: [Engagement, TransactionRating, ExportReport]
}
